<template>
  <a-tabs v-on:change="() => {}" type="card">
    <a-tab-pane v-bind:key="member.id" v-for="member in family">
      <template #tab>
        <CustomerBadgeComponent
          v-bind:customer="member"
          v-bind:link="false"
          v-bind:tooltip="false"
       />
      </template>

      <customer-page-responsive-layout>
        <template #content>
          <customer-current-living-condition-show-component
              v-bind:customer="member"
          />
        </template>

        <template #buttons>
          <ActionGroupListComponent v-bind:items="[
            {
              type: 'primary',
              icon: 'pencil',
              link: `/customer/${mainCustomer.id}/current_living_condition/edit`,
              name: 'Bewerken',
            },
          ]"/>
        </template>

        <template #side-content>
          <MapsComponent v-bind:customer="member"></MapsComponent>
        </template>
      </customer-page-responsive-layout>

    </a-tab-pane>
  </a-tabs>
</template>

<script>
import customerPropertyShowComponent from "~/modules/customer_property/components/ShowComponent";
import customerCurrentLivingConditionShowComponent from "./ShowComponent"
import mortgagePropertyApi from "~/api/mortgage_property"
import MapsComponent from "./MapsComponent";
import showRentalComponent from "./ShowRentalComponent";
import showResidentComponent from "./ShowResidentComponent";
import showPropertyComponent from "./ShowPropertyComponent";
import CustomerBadgeComponent from "~/modules/customer/components/BadgeComponent";


export default {
  name: "CustomerCurrentLivingConditionShowPageComponent",
  components: {
    CustomerBadgeComponent,
    showRentalComponent,
    customerPropertyShowComponent,
    customerCurrentLivingConditionShowComponent,
    showResidentComponent,
    showPropertyComponent,
    MapsComponent
  },
  props: {
    family: {
      required: true,
      type: Array,
    }
  },
  data() {
    return {
      currentLivingConditions: [],
    };
  },
  computed: {
    mainCustomer() {
      return this.family[0];
    }
  },
  mounted() {
  },
  methods: {
    initCurrentLivingConditions() {
      let promises = [];

      for (let key in this.family) {
        let member = this.family[key];
        promises.push();
      }

      return Promise.all(promises);
    },
    changeSelectedCurrentLivingCondition(selectedMemberId) {
      this.selectedCurrentLivingCondition = this.currentLivingConditions[selectedMemberId]
      this.selectedCurrentLivingConditionCollaterals = [];
      this.loadCollaterals(this.selectedCurrentLivingCondition)

    },
    currentLivingConditionByCustomer(customer) {
      return this.currentLivingConditions.find(currentLivingCondition => {
        if (currentLivingCondition.customer_property !== null && typeof currentLivingCondition.customer_property !== "undefined") {
          let customerProperty = currentLivingCondition.customer_property.data

          return customerProperty.customer_id === customer.id;
        }

        return false;
      })
    },
    customerPropertyByCustomer(customer) {
      return this.currentLivingConditions.find(currentLivingCondition => {
        if (currentLivingCondition.customer_property !== null && typeof currentLivingCondition.customer_property !== "undefined") {
          let customerProperty = currentLivingCondition.customer_property.data

          return customerProperty.customer_id === customer.id;
        }

        return false;
      })
    },
    customerShortName(customer) {
      let shortName = '';

      if (customer.initials !== null && customer.initials.length > 0) {
        shortName += customer.initials;
      } else if (customer.first_name) {
        shortName += customer.first_name;
      } else {
        shortName += customer.firstName;
      }

      if (customer.suffix !== null && customer.suffix.length > 0) {
        shortName += ' ' + customer.suffix;
      }

      if (customer.last_name) {
        shortName += ' ' + customer.last_name;
      } else {
        shortName += ' ' + customer.lastName;

      }

      //TODO:: add age

      return shortName;
    },
    loadCollaterals(customerCurrentLivingCondition) {
      if (customerCurrentLivingCondition && typeof customerCurrentLivingCondition.customer_property !== 'undefined' && typeof customerCurrentLivingCondition.customer_property.property !== 'undefined') {
        mortgagePropertyApi.findByPropertyForCustomer(customerCurrentLivingCondition.customer_property.property.id, customerCurrentLivingCondition.customer_property.customer_id, ['mortgage', 'property'])
            .then((response) => {
              this.selectedCurrentLivingConditionCollaterals = response.data;
            })
      }
    },

    edit() {
      window.location = '/customer/' + this.selectedFamilyMemberId + '/current_living_condition/edit';
    }
  }
}
</script>
<style scoped>
</style>
